import { Button, Grid2, InputAdornment, TextField} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as EditIcon } from '../../assets/SVG/aiEdit.svg';
import { ReactComponent as SearchIcon } from '../../assets/SVG/Search-Icon.svg';
import GradingResultsHistory from './GradingResultsHistory';
import { useGradingHistory } from './GradingHistoryContext';
import { useTranslation } from 'react-i18next';
import { getGradingHistory, handleNewAIGradingHelper } from './EmbryoGradingAi.helper';


const GradingHistoryLayoutSx = {
  bgcolor: '#f9fafb',
  padding: 2
};

const NewGradingSx = {
  width: '100%',
  fontFamily: 'Montserrat',
  backgroundColor: '#EFEFF2',
  borderRadius: 2,
  color: '#232323',
  fontWeight: 700,
  margin: 0,
  paddingX: 2,
  paddingY: 1.5,
  boxShadow: 'none',
};

const SearchFieldSx = {
  width: '100%',
  backgroundColor: '#FFFFFF',
};

const GradingHistory: React.FC = () => {

  const { toggleEmbryoGradingDetailsOpen , setSelectedPatientsForEmbryoGrading , selectedGradingHistory , toggleResultAvailable , setGradingHistoriesList , setLoadingHistory , setSelectedGradingHistory} = useGradingHistory();
  const { t: tAiGrading } = useTranslation('aiGrading_config');

  const [search, setSearch] = useState('');

  // new AI grading
  const handleNewAIGrading = () => {

    toggleResultAvailable(false); // start loader

    handleNewAIGradingHelper(
      toggleEmbryoGradingDetailsOpen,
      setSelectedPatientsForEmbryoGrading,
      setSelectedGradingHistory,
      setGradingHistoriesList
    );
  };


  const fetchGradingHistory = React.useCallback(async () => {
    setLoadingHistory(true);
    try {
      const data = await getGradingHistory({
        'name': search
      });
      if (Array.isArray(data.objects)) {
        // Map response to GradingHistoryItem[]
        const mappedHistory = data.objects.map((item: {
          id: number;
          name: string;
          trigger_source: string;
          triggered_by_name: string;
        }) => ({
          id: item.id,
          name: item.name,
          trigger_source: item.trigger_source,
          triggered_by_name: item.triggered_by_name,
          isSelected: selectedGradingHistory !== null ? item.id === selectedGradingHistory.id : false,
        }));
        setGradingHistoriesList(mappedHistory);
      }
    } catch (e: unknown) {
      // eslint-disable-next-line no-console
      console.log('error', e);
    } finally {
      setLoadingHistory(false);
    }
  }, [search , selectedGradingHistory, setGradingHistoriesList, setLoadingHistory]);




  useEffect(() => {
    fetchGradingHistory();
  }, [search, fetchGradingHistory]);



  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  return (
    <>     
      <Grid2 display="flex" alignItems="center" gap={1}  flexDirection="column" size={12} height={'100%'} sx={GradingHistoryLayoutSx} borderRadius={4} >

        <Grid2 mb={2} size={12}>
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            sx={NewGradingSx}
            onClick={handleNewAIGrading}
          >
            {tAiGrading('startNewAiGrading')}
          </Button>
        </Grid2> 

        <Grid2  mb={2} size={12}>
          <TextField
            size="small"
            placeholder={tAiGrading('search')}
            variant="outlined"
            value={search}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={SearchFieldSx}
          />
        </Grid2> 

        
        <Grid2  mb={2} size={12} height={'100%'}>
          <GradingResultsHistory />
        </Grid2> 

      </Grid2>

    </>
  );
};
  
export default GradingHistory;